import script from "./ResumeUploadDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ResumeUploadDialog.vue?vue&type=script&setup=true&lang=js"

import "./ResumeUploadDialog.vue?vue&type=style&index=0&id=4c0b4d8c&scoped=true&lang=less"

import exportComponent from "/var/www/tz-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c0b4d8c"]])

export default __exports__